import { StepNlpConfiguration, StepNlpSettings, StepSchema } from '@feedyou/schema'
import { isOfType } from './step'

export const GLOBAL_FALLBACK_STEP_NLP_CONFIGURATION: StepNlpConfiguration = {
  id: 'global-fallback-step-nlp-configuration',
  provider: { type: 'feedyou' }
}

export const NLP_DISABLED = '__NLP_DISABLED__'

export function getNlpConfigForStep(
  step: StepSchema,
  stepNlpSettings: StepNlpSettings = {}
): StepNlpConfiguration | undefined {
  const { configurations = [], defaultConfigurationId } = stepNlpSettings

  if (!isOfType(['question', 'prompt'])(step)) {
    return undefined // No other step types are currently supported
  }

  for (const configId of [step.nlpConfigurationId, defaultConfigurationId]) {
    if (configId === NLP_DISABLED) {
      return undefined
    }

    const foundConfig = configId && configurations?.find((config: any) => config.id === configId)

    // TODO: Tady je treba se pobavit o te funkcionalite. Nevezme to config pokud neexistuje,
    // ale z optionu to neni jasne
    if (foundConfig) {
      return foundConfig
    }
  }

  return configurations[0] ?? GLOBAL_FALLBACK_STEP_NLP_CONFIGURATION
}
